import React, {useEffect} from 'react'
import Slider from "react-slick";
import AOS from 'aos';
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import superFineGraphics from '../../src/Assets/Images/super-fine-graphics.png'
import broadCampaigns from '../../src/Assets/Images/marketing-campaigns.avif'
import printPackages from '../../src/Assets/Images/packaging-and-printing.avif'

function Hero() {

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1
      };

      useEffect(() => {
        AOS.init();
      }, []);

  return (
    <div>
      <Slider {...settings}>
          <div>
            <section className="hero-slider">
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center py-3">
                        
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration="2000">
                            <div className="hero-content">
                                <h6>We crush to make</h6>
                                <h2>Superfine Graphics For Your Business</h2>
                                <p>Delivering everything from creative concept to production, with perfection and professionalism</p>
                            </div>
                        </div>
                        
                        <div className="col-md-6" data-aos="fade-left" data-aos-duration="2000">
                            <img src={superFineGraphics} alt="super-fine-graphics" className="img-fluid" />
                        </div>
                        
                    </div>
                </div>
            </section>
          </div>
          <div>
          <section className="hero-slider">
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center py-3">
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration="2000">
                            <div className="hero-content">
                                <h6>Crafting impressions with precision</h6>
                                <h2>Print And Packaging Designs</h2>
                                <p>Sweets & bakers, fast food, industrial packaging, gorcery, botique & fashion, shoes box, cosmetics and restaurants.</p>
                            </div>
                        </div>
                        <div className="col-md-6" data-aos="fade-left" data-aos-duration="2000">
                            <img src={printPackages} alt="print-and-packaging-design" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>
          </div>
          <div>
          <section className="hero-slider">
                <div className="container">
                    <div className="row justify-content-center align-items-center py-3">
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration="2000">
                            <div className="hero-content">
                                <h6>We define the</h6>
                                <h2>Campaigns That Reach Out Broadly</h2>
                                <p>Since we started our business, we just know how to increase your extent in every manner</p>
                            </div>
                        </div>
                        <div className="col-md-6" data-aos="fade-left" data-aos-duration="2000">
                            <img src={broadCampaigns} alt="broad-marketing-campaigns" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>
          </div>
        </Slider>
    </div>
  )
}

export default Hero
